var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-preview" },
    _vm._l(_vm.files, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "upload-preview__item" },
        [
          _c(
            "removable-entry",
            {
              attrs: { truncate: "" },
              on: {
                close: function ($event) {
                  return _vm.$emit("remove", item.uploadedFileKey)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }